module.exports = __webpack_public_path__ + "static/media/33.8b0ab0d0.jpg";